import ImageUploader from './components/ImageUploader';

export default ImageUploader;
